import React from 'react';

const ClientDeliveries: React.FC = () => {
  return (
    <section className="px-4 py-16 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Nos Livraisons</h2>
          <p className="text-lg text-gray-600">Des milliers de clients nous font confiance chaque jour</p>
        </div>

        {/* Images Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          {/* Livraison 1 - Moto */}
          <div className="bg-gray-50 rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
            <div className="h-64 lg:h-72 w-full overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/73ae577bdace470735b1880ab535aebf.jpg"
                alt="Livraison express moto coursier Paris Île-de-France"
                title="Livraison express en moto - Coursier Paris"
                className="w-full h-full object-cover object-top"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-base font-bold text-gray-900">Livraison Express</p>
                  <p className="text-sm text-gray-600">Paris 15ème - 45 min</p>
                </div>
                <div className="flex items-center bg-green-100 px-4 py-2 rounded-full">
                  <i className="ri-check-line text-green-600 mr-2 text-lg"></i>
                  <span className="text-sm font-bold text-green-600">Livrée</span>
                </div>
              </div>
            </div>
          </div>

          {/* Livraison 2 - Utilitaire */}
          <div className="bg-gray-50 rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
            <div className="h-64 lg:h-72 w-full overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20delivery%20driver%20in%20uniform%20unloading%20large%20packages%20from%20white%20utility%20van%20to%20satisfied%20business%20customer%20at%20office%20building%20entrance%20daytime%20commercial%20delivery%20service%20professional%20logistics%20transportation%20business%20to%20business%20authentic%20scene%20high%20quality%20photography%20natural%20lighting&width=500&height=400&seq=client-delivery-van-002&orientation=landscape"
                alt="Transport professionnel utilitaire Île-de-France livraison entreprise"
                title="Transport professionnel en utilitaire - Île-de-France"
                className="w-full h-full object-cover object-top"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-base font-bold text-gray-900">Transport Professionnel</p>
                  <p className="text-sm text-gray-600">La Défense - 1h20</p>
                </div>
                <div className="flex items-center bg-green-100 px-4 py-2 rounded-full">
                  <i className="ri-check-line text-green-600 mr-2 text-lg"></i>
                  <span className="text-sm font-bold text-green-600">Livrée</span>
                </div>
              </div>
            </div>
          </div>

          {/* Livraison 3 - Moto Urgent */}
          <div className="bg-gray-50 rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
            <div className="h-64 lg:h-72 w-full overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Motorcycle%20courier%20in%20protective%20gear%20delivering%20urgent%20document%20package%20to%20elderly%20gentleman%20customer%20at%20residential%20doorstep%20golden%20hour%20lighting%20warm%20atmosphere%20customer%20care%20service%20quality%20interaction%20authentic%20scene%20professional%20delivery%20service%20high%20quality%20photography%20natural%20lighting&width=500&height=400&seq=client-delivery-urgent-003&orientation=landscape"
                alt="Coursier moto urgent livraison documents Paris région"
                title="Livraison urgente par coursier moto - Paris"
                className="w-full h-full object-cover object-top"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-base font-bold text-gray-900">Livraison Urgente</p>
                  <p className="text-sm text-gray-600">Montmartre - 30 min</p>
                </div>
                <div className="flex items-center bg-green-100 px-4 py-2 rounded-full">
                  <i className="ri-check-line text-green-600 mr-2 text-lg"></i>
                  <span className="text-sm font-bold text-green-600">Livrée</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="tel:+33631012910"
            className="inline-flex items-center justify-center bg-red-600 text-white px-10 py-5 rounded-xl text-lg font-bold hover:bg-red-700 transition-all shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-3 text-2xl"></i>
            COMMANDEZ VOTRE LIVRAISON
          </a>
        </div>
      </div>
    </section>
  );
};

export default ClientDeliveries;